import { render, staticRenderFns } from "./QuangCaoForm.vue?vue&type=template&id=7bac927c&scoped=true"
import script from "./QuangCaoForm.vue?vue&type=script&lang=js"
export * from "./QuangCaoForm.vue?vue&type=script&lang=js"
import style0 from "./QuangCaoForm.vue?vue&type=style&index=0&id=7bac927c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bac927c",
  null
  
)

export default component.exports